/**
 * just returns the company id, id not find it, the 36 is default
 */
const path = window.location.pathname.length > 1 ? 
    window.location.pathname.split("/") 
    : ""; 

export default Array.isArray(path) ? path[1] : path;